import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Header from '../Pages/Header';
import Sidebar from '../Pages/Sidebar';
import axios from 'axios';
import { PAY_URL } from '../../../BaseURL';
import toast from 'react-hot-toast';

const LoanStatus = () => {

    const navigate = useNavigate();
    const [entity, setEntity] = useState(null);
    const [disable, setDisable] = useState(true);
    const [date, setDate] = useState({
        startDate: null,
        endDate: null
    });
    const [searchText, setSearchText] = useState('');
    const [employeeData, setEmployeeData] = useState([]);
    const [loanData, setLoanData] = useState([]);
    const [empId, setEmpId] = useState(null);
    const [empFilter, setEmpFilter] = useState([]);

    useEffect(() => {
        if (localStorage.getItem('PAY_USER_TOKEN') === null) {
            navigate("/user/login");
        }
        if (disable) {
            setEntity(null);
            getLoanStatus();
        }
        getEmployee();
        getLoan();
    }, [disable, navigate]);

    const getEmployee = () => {
        const myurl = `${PAY_URL}/user/list-employee-all?firm_id=${localStorage.getItem('PAY_USER_FIRM_ID')}`;
        axios({
            method: "get",
            url: myurl,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then(async (response) => {
            if (response?.data?.success) {
                const data = response?.data?.data
                setEmployeeData(data);
            } else {
                toast.error(response?.data?.message);
            }
        }).catch((error) => {
            toast.error(error?.response?.data?.message || "Something went wrong");
            console?.log("Errors", error);
        });
    }

    const getLoanStatus = (employeeId) => {
        if (employeeId) {
            const URL = `${PAY_URL}/user/get-loan-summary/${employeeId}?startDate=${date.startDate}&endDate=${date.endDate}`;
            axios({
                method: "GET",
                url: URL,
                headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
            }).then((response) => {
                const { success, data, message } = response?.data
                if (success) {
                    setEntity(data);
                }
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                setDisable(false);
            })
        }
    }

    const getLoan = () => {
        const myurl = `${PAY_URL}/user/get-admin-loan?firm=${localStorage.getItem('PAY_USER_FIRM_ID')}`;
        axios({
            method: "get",
            url: myurl,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then(async (response) => {
            if (response?.data?.success) {
                const data = response?.data?.data
                setLoanData(data);
            } else {
                toast.error("Something went wrong");
            }
        }).catch((error) => {
            toast.error("Something went wrong");
            console?.log("Errors", error);
        });
    }

    useEffect(() => {
        const employeeIdsWithLoan = new Set(
            loanData.map(loan => loan?.employee?._id)
        );
        const finalEmployeeList = employeeData?.filter(emp =>
            employeeIdsWithLoan.has(emp._id)
        );
        setEmpFilter(finalEmployeeList);
    }, [loanData, employeeData]);

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title user-title">Loan Management</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/user/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">Loan Status Management</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="content container-fluid">
                        <div className="row">
                            {/* Employee List */}
                            <div className="col-md-4">
                                <div className="card">
                                    <div className="card-header"><strong>Employee List</strong></div>
                                    <div className="card-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                        <div className='d-flex justify-content-between align-items-center mb-3 gap-2'>
                                            <input
                                                type="text"
                                                placeholder="Search by name or card no"
                                                className="form-control"
                                                value={searchText}
                                                onChange={(e) => setSearchText(e.target.value)}
                                            />
                                            {searchText && (
                                                <button className="btn btn-outline-secondary" onClick={() => setSearchText('')}>
                                                    Clear
                                                </button>
                                            )}
                                        </div>
                                        {empFilter
                                            ?.filter((emp) =>
                                                emp.full_name.toLowerCase().includes(searchText.toLowerCase()) ||
                                                emp.card_no.toString().includes(searchText)
                                            )
                                            ?.map((emp) => (
                                                <div
                                                    key={emp._id}
                                                    onClick={() => {
                                                        setEmpId(emp._id);
                                                        getLoanStatus(emp._id);
                                                    }}
                                                    className={`border p-2 mb-2 rounded cursor-pointer ${emp._id === empId ? 'bg-light' : ''}`}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <h5 className="mb-1">{emp.full_name}</h5>
                                                    <p className="mb-0 text-muted">{emp.designation.name}</p>
                                                    <small>Card No: {emp.card_no}</small>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-8">
                                <div className="card">
                                    <div className="card-header"><strong>Loan Summary</strong></div>
                                    <div className="card-body">
                                        {entity ? (
                                            <>
                                                <p><strong>Opening Balance:</strong> ₹{entity.openingBalance}</p>
                                                <p><strong>Total Taken:</strong> ₹{entity.totalTaken}</p>
                                                <p><strong>Total Paid:</strong> ₹{entity.totalPaid}</p>
                                                <p><strong>Closing Balance:</strong> ₹{entity.closingBalance}</p>
                                                <p><strong>Status:</strong> {entity.status}</p>

                                                <hr />
                                                <h5>Loan Details</h5>
                                                {/* <ul className="list-group">
                                                    {entity?.loanDetails?.map((item, index) => (
                                                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <p className="mb-0"><strong>{item.type.toUpperCase()}</strong> ₹{item.amount}</p>
                                                                <small>{new Date(item.date).toLocaleDateString()}</small>
                                                            </div>
                                                            <span className="badge bg-primary rounded-pill">Bal: ₹{item.runningBalance}</span>
                                                        </li>
                                                    ))}
                                                </ul> */}
                                                <table className="table table-bordered table-hover mt-3">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Type</th>
                                                            <th>Amount</th>
                                                            <th>Date</th>
                                                            <th>Voucher No</th>
                                                            <th>Remark</th>
                                                            <th>Running Balance</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {entity?.loanDetails?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.type.toUpperCase()}</td>
                                                                <td>₹{item.amount}</td>
                                                                <td>{new Date(item.date).toLocaleDateString()}</td>
                                                                <td>{item?.voucher_no || '—'}</td>
                                                                <td>{item?.remark || '—'}</td>
                                                                <td>₹{item.runningBalance}</td>
                                                                <td>{item.status}</td>
                                                            </tr>
                                                        ))}
                                                        {entity?.loanDetails?.length === 0 && (
                                                            <tr>
                                                                <td colSpan="8" className="text-center">No loan details available</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </>
                                        ) : (
                                            <p>Select an employee to view loan summary</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default LoanStatus